<template>
  <el-container>
    <el-main>
      <el-form ref="form" label-width="80px">
        <div v-for="(item, index) in honorList" :key="index">
          <el-divider content-position="left">资质特权 {{index+1}}</el-divider>
          <el-form-item label="资质名称">
            <el-input @change="change($event, item, index)" v-model="item.name"></el-input>
          </el-form-item>
          <el-form-item label="资质时间">
            <el-date-picker
              @blur="change($event, item, index)"
              v-model="item.date"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button :loading="saveLoading" type="primary" @click="save" icon="el-icon-s-promotion">保存</el-button>
          <el-button type="primary" @click="addHonor" icon="el-icon-plus">添加资质特权</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import $http from "../../../request.js";
import _ from "lodash";
export default {
  name: "companyqualifications",
  created(){
    this.getList();
    // this.updateHonorList(this.list);
  },
  computed:{
    ...mapState([
      "defaultInfo",
      "area"
    ])
  },
  props:{
    company_id:{
      type: [String, Number],
      default: ""
    }
  },
  watch:{
    list(list){
      this.updateHonorList(list);
    }
  },
  data(){
    return {
      item:"",
      index: "",
      saveLoading: false,
      list: [],
      honorList: [
        {
          name: "",
          date: ""
        }
      ]
    };
  },
  methods:{
    save(){
      const item = this.item;
      if(item){
        const params = {
          company_id: this.company_id,
          id: item.id||'',
          name: item.name,
          start_date: item.date[0],
          end_date: item.date[1]
        }
        let toupdate = true;
        _.forIn(params, (val, key)=>{
          if (!val&&key!=='id') {
            toupdate = false;
          }
        });
        if (toupdate) {
          this.updateHonor(params);
        }
      } else {
        this.$message("没有新的内容");
      }
    },
    getList(){
      const loading = this.$loading({
        lock: true,
        text: 'Loading'
      });
      $http.post("/api/company/company_qualification/getList", {
        company_id: this.company_id
      })
        .then(res=>{
          loading.close();
          this.updateHonorList(res.data.data);
        });
    },
    updateHonorList(list){
      this.honorList = list.map(v=>{
        v.date = [
          v.start_date,
          v.end_date
        ];
        return v;
      });
    },
    addHonor(){
      this.honorList = [
        ...this.honorList,
        {
          name: "",
          date: ""
        }
      ]
    },
    updateHonor(params) {
      this.saveLoading = true;
      let url = "/api/company/company_qualification/add";
      if(params.id) {
        url = "/api/company/company_qualification/edit";
      }
      $http.post(url, params)
        .then(res=>{
          this.saveLoading = false;
          if (res.data.code===1){
            this.$message({
              message: params.id?"修改成功":"新增成功",
              type: 'success'
            });
            this.item = "";
            this.index = "";
            this.$emit('success');
          }
        })
        .catch(()=>{
          this.saveLoading = false;
        });
    },
    focus(index){
      this.activeIndex = index;
    },
    change(e, item, index) {
      this.honorList[index] = item;
      this.item = item;
      this.index = index;
    }
  }
};
</script>

<style lang="less">
  
</style>

